<div class="message-container draft" *ngIf="signatureObject.clientSignature && signatureObject.clientSignature.status === 'DRAFT'">
	<div class="message" (click)="expanded = !expanded"><em class="fas fa-file-signature"></em> <span>A draft request was previously created</span> <em *ngIf="!expanded" class="fas fa-angle-down expand"></em><em *ngIf="expanded" class="fas fa-angle-up expand"></em></div>
	<ng-container *ngIf="expanded">
		<div class="data">
			<div class="left">Created</div>
			<div class="right">{{ signatureObject.clientSignature.signatureRequestDate | date:'MMM d, y' }}</div>
		</div>
		<div class="data" *ngFor="let participant of signatureObject.participants; let j = index">
			<div class="left">Signer {{ j + 1 }}</div>
			<div class="right" [title]="participant.memberInfos[0].email">
				{{ participant.memberInfos[0].name }}
			</div>
		</div>
		<div class="data">
			<div class="left">Status</div>
			<div class="right">
				<span *ngIf="!loadingCancelRequest">{{ signatureObject.clientSignature.status }}</span>
				<i *ngIf="loadingCancelRequest" class="fas fa-spinner fa-spin"></i>
			</div>
		</div>
		<div class="data" *ngIf="signatureObject.clientSignature.signatureExpirationDate">
			<div class="left">Expiration Date</div>
			<div class="right">{{ signatureObject.clientSignature.signatureExpirationDate | date:'MMM d, y' }}</div>
		</div>
		<div class="actions">
			<button type="button" class="btn btn-primary btn-md left" (click)="cancelRequest(signatureObject.clientSignature)" [disabled]="loadingCancelRequest || loadingSendReminder">Cancel Draft</button>
			<button *ngIf="contextService.signatureCount.signatures.used < contextService.signatureCount.signatures.total" type="button" class="btn btn-primary btn-md right" (click)="continueRequest(signatureObject.clientSignature)" [disabled]="loadingCancelRequest || loadingContinueRequest">Continue Draft</button>
			<button *ngIf="contextService.signatureCount.signatures.used >= contextService.signatureCount.signatures.total" type="button" class="btn btn-primary btn-md right" [disabled]="true" title="You are out of signature requests">Continue Draft</button>
		</div>
	</ng-container>
</div>

<div class="message-container requested" *ngIf="signatureObject.clientSignature && signatureObject.clientSignature.status === 'REQUESTED'">
	<!-- <div *ngIf="signatureRequestExpired" class="message"><em class="fas fa-info-circle"></em> <span>The signature request has expired</span> <em *ngIf="!expanded" class="fas fa-angle-down expand"></em><em *ngIf="expanded" class="fas fa-angle-up expand"></em></div> -->
	<div class="message" (click)="expanded = !expanded"><em class="fas fa-paper-plane"></em> <span>A signature request has been sent</span> <em *ngIf="!expanded" class="fas fa-angle-down expand"></em><em *ngIf="expanded" class="fas fa-angle-up expand"></em></div>
	<ng-container *ngIf="expanded">
		<div class="data">
			<div class="left">Sent</div>
			<div class="right">{{ signatureObject.clientSignature.signatureRequestDate | date:'MMM d, y' }}</div>
		</div>
		<div class="data" *ngFor="let participant of signatureObject.participants; let j = index">
			<div class="left">Signer {{ j + 1 }}</div>
			<div class="right" [title]="participant.memberInfos[0].email">
				{{ participant.memberInfos[0].name }}
				<i *ngIf="participant.status === 'WAITING_FOR_OTHERS'" class="fas fa-check signer-icon" title="Signed"></i>
				<i *ngIf="participant.status === 'WAITING_FOR_MY_SIGNATURE'" class="fas fa-envelope signer-icon" title="Awaiting signature"></i>
				<i *ngIf="participant.status === 'NOT_YET_VISIBLE'" class="fas fa-ellipsis-h signer-icon" title="Not yet sent"></i>
			</div>
		</div>
		<div class="data">
			<div class="left">Status</div>
			<div class="right">
				<span *ngIf="!loadingCancelRequest">{{ signatureObject.clientSignature.status }}</span>
				<i *ngIf="loadingCancelRequest" class="fas fa-spinner fa-spin"></i>

			</div>
		</div>
		<div class="data" *ngIf="signatureObject.clientSignature.signatureExpirationDate">
			<div class="left">Expiration Date</div>
			<div class="right">{{ signatureObject.clientSignature.signatureExpirationDate | date:'MMM d, y' }}</div>
		</div>
		<div class="actions">
			<button type="button" class="btn btn-primary btn-md left" (click)="cancelRequest(signatureObject.clientSignature)" [disabled]="loadingCancelRequest || loadingSendReminder">Cancel Request</button>
			<!-- <button type="button" class="btn btn-primary btn-md middle" (click)="sendReminder(signatureObject.clientSignature)" [disabled]="loadingCancelRequest || loadingSendReminder">Send Reminder</button> -->
			<button type="button" class="btn btn-primary btn-md right" (click)="viewRequest()" [disabled]="loadingCancelRequest || loadingSendReminder">View In Adobe Sign</button>
		</div>
	</ng-container>
</div>

<div class="message-container declined" *ngIf="signatureObject.clientSignature && signatureObject.clientSignature.status === 'CANCELLED'">
	<div class="message" (click)="expanded = !expanded"><em class="fas fa-trash-alt"></em> <span>A request has been cancelled</span> <em *ngIf="!expanded" class="fas fa-angle-down expand"></em><em *ngIf="expanded" class="fas fa-angle-up expand"></em></div>
	<ng-container *ngIf="expanded">
		<div class="data">
			<div class="left">Sent</div>
			<div class="right">{{ signatureObject.clientSignature.signatureRequestDate | date:'MMM d, y' }}</div>
		</div>
		<div class="data" *ngFor="let participant of signatureObject.participants; let j = index">
			<div class="left">Signer {{ j + 1 }}</div>
			<div class="right" [title]="participant.memberInfos[0].email">
				{{ participant.memberInfos[0].name }}
				<!-- <i *ngIf="signatory.status === 'awaiting_signature' && !signatory.viewedAt" class="fas fa-envelope signer-icon" title="Awaiting signature"></i>
						<i *ngIf="signatory.status === 'awaiting_signature' && signatory.viewedAt" class="fas fa-eye signer-icon" title="Viewed"></i>
						<i *ngIf="signatory.status === 'signed' || signatory.status === 'success'" class="fas fa-check signer-icon" title="Signed"></i> -->
			</div>
		</div>
		<div class="data">
			<div class="left">Status</div>
			<div class="right">{{ signatureObject.clientSignature.status }}</div>
		</div>
		<div class="actions">
			<button type="button" class="btn btn-primary btn-md" (click)="viewRequest()" [disabled]="loadingCancelRequest || loadingSendReminder">View In Adobe Sign</button>
		</div>
	</ng-container>
</div>

<div class="message-container declined" *ngIf="signatureObject.clientSignature && signatureObject.clientSignature.status === 'DECLINED'">
	<div class="message" (click)="expanded = !expanded"><em class="fas fa-thumbs-down"></em> <span>A request has been declined</span> <em *ngIf="!expanded" class="fas fa-angle-down expand"></em><em *ngIf="expanded" class="fas fa-angle-up expand"></em></div>
	<ng-container *ngIf="expanded">
		<div class="data">
			<div class="left">Sent</div>
			<div class="right">{{ signatureObject.clientSignature.signatureRequestDate | date:'MMM d, y' }}</div>
		</div>
		<div class="data" *ngFor="let participant of signatureObject.participants; let j = index">
			<div class="left">Signer {{ j + 1 }}</div>
			<div class="right" [title]="participant.memberInfos[0].email">
				{{ participant.memberInfos[0].name }}
				<!-- <i *ngIf="signatory.status === 'awaiting_signature' && !signatory.viewedAt" class="fas fa-envelope signer-icon" title="Awaiting signature"></i>
						<i *ngIf="signatory.status === 'awaiting_signature' && signatory.viewedAt" class="fas fa-eye signer-icon" title="Viewed"></i>
						<i *ngIf="signatory.status === 'signed' || signatory.status === 'success'" class="fas fa-check signer-icon" title="Signed"></i> -->
			</div>
		</div>
		<div class="data">
			<div class="left">Status</div>
			<div class="right">{{ signatureObject.clientSignature.status }}</div>
		</div>
		<div class="actions">
			<button type="button" class="btn btn-primary btn-md" (click)="viewRequest()" [disabled]="loadingCancelRequest || loadingSendReminder">View In Adobe Sign</button>
		</div>
	</ng-container>
</div>

<div class="message-container completed" *ngIf="signatureObject.clientSignature && signatureObject.clientSignature.status === 'COMPLETED'">
	<div class="message" (click)="expanded = !expanded"><em class="fas fa-check"></em> <span>A request has been completed</span> <em *ngIf="!expanded" class="fas fa-angle-down expand"></em><em *ngIf="expanded" class="fas fa-angle-up expand"></em></div>
	<ng-container *ngIf="expanded">
		<div class="data">
			<div class="left">Sent</div>
			<div class="right">{{ signatureObject.clientSignature.signatureRequestDate | date:'MMM d, y' }}</div>
		</div>
		<div class="data">
			<div class="left">Completed</div>
			<div class="right">{{ signatureObject.clientSignature.signatureCompleteDate | date:'MMM d, y' }}</div>
		</div>
		<div class="data" *ngFor="let participant of signatureObject.participants; let j = index">
			<div class="left">Signer {{ j + 1 }}</div>
			<div class="right" [title]="participant.memberInfos[0].email">
				{{ participant.memberInfos[0].name }}
				<!-- <i *ngIf="signatory.status === 'awaiting_signature' && !signatory.viewedAt" class="fas fa-envelope signer-icon" title="Awaiting signature"></i>
						<i *ngIf="signatory.status === 'awaiting_signature' && signatory.viewedAt" class="fas fa-eye signer-icon" title="Viewed"></i>
						<i *ngIf="signatory.status === 'signed' || signatory.status === 'success'" class="fas fa-check signer-icon" title="Signed"></i> -->
			</div>
		</div>
		<div class="actions">
			<button type="button" class="btn btn-primary btn-md" (click)="viewRequest()" [disabled]="loadingCancelRequest || loadingSendReminder">View In Adobe Sign</button>
			<!-- <button type="button" class="btn btn-primary btn-md right" (click)="downloadRequest()" [disabled]="loadingCancelRequest || loadingSendReminder">Download File</button> -->
		</div>
	</ng-container>
</div>